export default __webpack_public_path__ + "static/media/rating_4.798917f1.svg";